import { Form, Input, Select, Button } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { NUMERIC_PATTERN } from '../../../../../../config/patterns';
import { serviceItems } from './data';
import BaseReCaptcha from '../../../../../../components/BaseReCaptcha';

export default function RegisterForm({
  form,
  onFinish,
  onCancel,
  submitLoadingStatus
}) {
  return (
    <div className="register-form">
      <span className="register-form__close-btn" onClick={onCancel}>
        &#10005;
      </span>
      <figure className="register-form__mobile-img">
        <img
          src="/images/home/register-form/m-register-form-bg.png"
          alt="Mobile background"
        />
      </figure>
      <div className="register-form__container">
        <h2 className="register-form__header">
          Experience bravoSUITE&apos;s features yourself!
        </h2>
        <Form
          className="register-form__form"
          form={form}
          layout="vertical"
          onFinish={onFinish}
        >
          <p className="register-form__label">
            Brief information about yourself.
          </p>
          <Form.Item name="company" className="register-form__item">
            <Input
              className="register-form-item__input"
              placeholder="Your company"
              size="large"
              type="text"
              aria-label="Company"
            />
          </Form.Item>
          <Form.Item
            name="name"
            className="register-form__item"
            rules={[
              {
                required: true,
                message: 'Please enter your name'
              }
            ]}
          >
            <Input
              className="register-form-item__input"
              placeholder="Your name*"
              size="large"
              type="text"
              aria-label="Your name"
              aria-required
            />
          </Form.Item>
          <Form.Item name="position" className="register-form__item">
            <Input
              className="register-form-item__input"
              placeholder="Your position"
              size="large"
              type="text"
              aria-label="Your position"
            />
          </Form.Item>
          <Form.Item
            name="email"
            className="register-form__item"
            rules={[
              {
                required: true,
                message: 'Please enter your email'
              },
              {
                message: 'Invalid email',
                type: 'email'
              }
            ]}
          >
            <Input
              className="register-form-item__input"
              placeholder="Work email*"
              size="large"
              type="email"
              aria-label="Work email"
            />
          </Form.Item>
          <Form.Item
            name="phoneNumber"
            className="register-form__item"
            rules={[
              {
                required: true,
                message: 'Please enter your phone number'
              },
              {
                message: 'Invalid phone number',
                pattern: NUMERIC_PATTERN
              }
            ]}
          >
            <Input
              className="register-form-item__input"
              placeholder="Phone number*"
              size="large"
              type="tel"
              aria-label="Phone number"
              aria-required
            />
          </Form.Item>
          <Form.Item
            className="register-form-item__input"
            name="g-recaptcha-response"
            rules={[
              {
                required: true,
                message: 'Captcha is required'
              }
            ]}
          >
            <BaseReCaptcha />
          </Form.Item>
          <p className="register-form__label">You are interested in</p>
          <Form.Item
            name="service"
            className="register-form__item"
            rules={[{ required: true }]}
            initialValue={serviceItems[0].value}
          >
            <Select
              aria-label="Customer service"
              className="register-form-item__select"
              defaultActiveFirstOption
              dropdownMatchSelectWidth
              placeholder="Select a option and change input text above"
              size="large"
              suffixIcon={<span className="suffix-icon triangle-down" />}
            >
              {serviceItems.map((item) => (
                <Select.Option key={item.id} value={item.value}>
                  {item.value}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item className="register-form__item">
            <Button
              htmlType="submit"
              className="register-form-item__submit-btn"
              loading={submitLoadingStatus}
            >
              Send
            </Button>
          </Form.Item>
          <figure className="register-form__img small-macbook">
            <img
              src="/images/home/register-form/small-macbook.webp"
              alt="macbook2"
            />
          </figure>
          <figure className="register-form__img big-macbook">
            <img
              src="/images/home/register-form/big-macbook.webp"
              alt="macbook1"
            />
          </figure>
        </Form>
      </div>
    </div>
  );
}

RegisterForm.propTypes = {
  form: PropTypes.shape({}).isRequired,
  onFinish: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  submitLoadingStatus: PropTypes.bool.isRequired
};
